'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var fieldErrorsShape = _react.PropTypes.shape({
  classification: _react.PropTypes.string,
  message: _react.PropTypes.string,
  id: _react.PropTypes.string,
  values: _react.PropTypes.object
});

exports.default = fieldErrorsShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/bc-prop-types/lib/components/fieldErrorsShape.js
// module id = 1375
// module chunks = 1